<template>
  <b-card class="card-transaction" no-body>
    <b-card-header>
      <b-card-title>تفاصيل الزيارات</b-card-title>
    </b-card-header>

    <b-card-body>
      <div
        v-for="transaction in transactionData"
        :key="transaction.mode"
        class="transaction-item"
      >
        <b-media no-body>
          <b-media-aside>
            <b-avatar rounded size="42" :variant="transaction.avatarVariant">
              <feather-icon size="18" :icon="transaction.avatar" />
            </b-avatar>
          </b-media-aside>
          <b-media-body>
            <h6 class="transaction-title">
              {{ transaction.mode }}
            </h6>
          </b-media-body>
        </b-media>
        <div class="font-weight-bolder text-light-dark">
          {{ transaction.value }}
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BMediaBody,
  BMedia,
  BMediaAside,
  BAvatar,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMediaBody,
    BMedia,
    BMediaAside,
    BAvatar,
  },
  data() {
    return {
      transactionData: [
        {
          mode: "الرئيسية",
          types: "good",
          avatar: "HomeIcon",
          avatarVariant: "light-primary",
          value: "74",
          deduction: true,
        },
        {
          mode: "الخدمات",
          avatar: "PackageIcon",
          avatarVariant: "light-info",
          value: "480",
          deduction: false,
        },
        {
          mode: "الأنشطة",

          avatar: "ActivityIcon",
          avatarVariant: "light-danger",
          value: "480",
          deduction: false,
        },
        {
          mode: "التبرع",
          avatar: "DollarSignIcon",
          avatarVariant: "light-success",
          value: "23",
          deduction: true,
        },
        {
          mode: "اتصل بنا",
          avatar: "PhoneCallIcon",
          avatarVariant: "light-info",
          value: "98",
          deduction: false,
        },
      ],
    };
  },
};
</script>
